<!--
 * @Author: Smion Li
 * @Date: 2025-02-20 16:38:14
 * @LastEditTime: 2025-02-20 19:52:52
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/venue-home/component/CategoryListButton/index.vue
-->
<style scoped lang="sass">

.category_list_button
  position: absolute
  margin-left: 5px

  .button
    color: var(--menu-primary-text-colour) !important
    .list_button
      color: var(--menu-primary-text-colour) !important
</style>

<template lang="pug">
  .category_list_button
    .button
      icon(size="30").list_button(@click="showDialog") list
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  props: {
  }
})
class CategoryListButton extends Vue {
  show = false

  showDialog() {
    this.show = true
    this.$emit('update:showCategoryListDialog', true)
    if (this.$openreplayTracker) {
      this.$openreplayTracker.event('clickCategoryListButton')
    }

    if (this.$gtag) {
      this.$gtag.event('special_click', {
        event_category: 'category_list_button',
        event_label: 'HomePage',
      })
    }
  }

  onSelect(item) {
    // 默认情况下点击选项时不会自动收起
    // 可以通过 close-on-click-action 属性开启自动收起
    this.show = false
    this.$emit('clickCategory', item)
  }
}

export default CategoryListButton
</script>
